$(function () {
    const filtersContainersClass = '.products-filter--container';
    const productToolsFiltersContainerClass = '.product-tools-filters';
    const $filtersContainer = $('.products-filter--container');
    const $sideScrollBtnPrev = $('#scrollNavFiltersPrev');
    const $sideScrollBtnNext = $('#scrollNavFiltersNext');
    const $sideScrollContainer = $('.navSideScroll');
    const sliderContainer = document.querySelector('.catalog-nav__sub-items');
    const sideScrollContainer = document.querySelector('.navSideScroll');
    const ACTION_CAUSE_FACET_SELECT = "facetSelect";
    const ACTION_CAUSE_FACET_DESELECT = "facetDeselect";
    const ACTION_CAUSE_FACET_CLEAR_ALL = "facetClearAll";
    const SORT_ORDER_PARAM = "?sortOrder=";
    const QUICK_SHOP_FILTER_ENCODED = '%3Aquickshop%3A';
    const FILTER_ENCODED_REGEX = '/%3A([^%]+?)%3A/';
    let sliderScrollWidth;
    let sliderWidth;
    if ($sideScrollContainer.length != 0) {
        sliderScrollWidth = sideScrollContainer.scrollWidth;
        sliderWidth = sliderContainer.offsetWidth;
    }
    let lastFilterValue = '';
    let lastSelectedFilterId = '';
    let filterToApply = '';
    let filtersSelected = [];
    let facetPosition = -1;
    let valuePosition = -1;

    /**************************************************************************
     * PRODUCT FILTER FUNCTIONS (EGC COMPONENT)
     **************************************************************************/
    $('.products-view li a[href=#]').click(function (e) {
        TINK.setCookie('pageSize', $(this).attr('data-page-size'));
        window.location = $(this).attr('data-href');
        e.preventDefault();
    });

    $('.product-filter-container .pt--filter-selected button').click(function () {
        navigate($(this).data('custom'), $(this).data('href'), false, false);
    });

    bindEventOnFilterClick($(filtersContainersClass));
    bindEventOnProductToolsFilterClick($(productToolsFiltersContainerClass));
    bindShowHideMoreFilters($(filtersContainersClass));
    bindToggleFilter($(filtersContainersClass));
    bindCategoryExpand($(filtersContainersClass));
    preventWrappingMobile();

    //****************************************************************
    // Bind
    //****************************************************************

    const closeFilterNav = function () {
        $('body').removeClass('overflow-hidden');
        $filtersContainer.removeClass('pf--active');
        $('.filter-overlay').remove();
        $('.openFilter').attr('aria-expanded', 'false');

        // when closing side-panel from the closing button, we need to reset the selected but not-applied filters
        if (filtersSelected.length > 0) {
            for (var i = 0; i < filtersSelected.length; i++) {
                let selector = `.checkbox--standard input[type="checkbox"][data-value-name="${filtersSelected[i]}"]`;
                let $checkboxSelected = $(filtersContainersClass).find(selector);
                $checkboxSelected.prop('checked', false);
            }

            if (typeof lang !== 'undefined' && lang === 'en') {
                $(filtersContainersClass).find('a.applyFilters .mfb--number span').text("Apply");
            } else {
                $(filtersContainersClass).find('a.applyFilters .mfb--number span').text("Appliquer");
            }
            $(filtersContainersClass).find('a.applyFilters').attr('href', window.location.href);
            navigate(false, encodeURIComponent(freeTextSearch), true, true, ACTION_CAUSE_FACET_CLEAR_ALL);
            filtersSelected = [];
        }
    }

    const manageCloseFilterOverlay = function (hasNewFilter) {
        if (hasNewFilter) {
            deactivateMobileFilters($(filtersContainersClass));
            window.location = $(filtersContainersClass).find('a.applyFilters').attr('href');
        } else {
            $('.filter-overlay').on('click', function (e) {
                if (e.target === this) {
                    filtersSelected = [];
                    closeFilterNav();
                }
            });
        }
    }

    $(document).on('click', '.closeFilter', function () {
        closeFilterNav();
    });

    function bindEventOnFilterClick($container) {
        $container.find('a.applyFilters').on('click', function () {

            if (isAislePage()) {
                const selectedFilters = [];
                $container.find(".checkbox--standard input[type=checkbox]:checked").each(function () {
                    const selectedFiltersCategory = $(this).closest('.accordion--item').find('.accordion--btn').text().toLowerCase().trim();
                    const selectedFiltersOption = $(this).siblings('.checkbox--label').find('.filter-name').text().toLowerCase().trim();

                    selectedFilters.push({selectedFiltersCategory, selectedFiltersOption})

                    pushDataLayerProductCatalogFilterBy('side panel', selectedFiltersCategory, selectedFiltersOption);
                });

                $container.find(".checkbox--standard input[type=checkbox]:checked").prop('checked', false);
            }
            // fix ga4 bug T4286-12840
            sessionStorage.setItem('isFromFilter', true);
            filtersSelected = [];
        });

        $container.find(".checkbox--standard input[type=checkbox]").change(function () {
            lastSelectedFilterId = this.id;
            let actionCause = $(this).is(":checked") ? ACTION_CAUSE_FACET_SELECT : ACTION_CAUSE_FACET_DESELECT;

            // Determine facet position
            facetPosition = -1;
            valuePosition = -1;
            const $accordionItems = $('.accordion--item');
            const $accordionItem = $(this).closest('.accordion--item');
            if ($accordionItem && $accordionItem.length) {
                const $checkboxes = $accordionItem.find("input[type=checkbox]");
                if ($checkboxes.index(this) !== -1) {
                    facetPosition = $accordionItems.index($accordionItem);
                    valuePosition = $checkboxes.index(this) + 1;
                }
            }

            // save the selected filters in filtersSelected
            filtersSelected.push($(this).data('value-name'));
            navigate($(this).data('custom'), $(this).attr('value'), false, true, actionCause);
        });

        $container.find(".radio--standard input[type=radio]").change(function () {
            let actionCause = $(this).attr('checked') ? ACTION_CAUSE_FACET_DESELECT : ACTION_CAUSE_FACET_SELECT;
            navigate($(this).data('custom'), null, false, true, actionCause, this.value);
        });

        $container.find('a.removeAllFilters').on('click', function () {
            if (typeof freeTextSearch !== 'undefined') {
                let filter = freeTextSearch.split(':')[0];
                navigate(false, filter, true, true, ACTION_CAUSE_FACET_CLEAR_ALL);
            } else {
                navigate(false, null, true, true, ACTION_CAUSE_FACET_CLEAR_ALL);
            }
            // fix ga4 bug T4286-12840
            sessionStorage.setItem('isFromFilter', true);
        });

        $('.removeAllFiltersMobile').on('click', function () {
            $('a.removeAllFilters').click();
        });

        $container.find('a.applyFilters').on('click', function () {
            deactivateMobileFilters($container);
        });

        $('.openFilter').bind('click', function () {
            const $body = $('body');
            $body.addClass('overflow-hidden');
            $filtersContainer.addClass('pf--active');
            $('.filter-overlay').remove();
            TINK.trapFocus($('.product-filter--form-content'), closeFilterNav);
            $body.append('<span class="filter-overlay" />');
            manageCloseFilterOverlay(false);
        });

        $('.filter-overlay').on('click', function (e) {
            if (e.target === this) {
                manageCloseFilterOverlay(true);
            }
        });

        $container.find('a.applyFilters').attr('href', lastFilterValue);
    }

    function bindEventOnProductToolsFilterClick($container) {
        $container.find(".checkbox--standard input[type=checkbox]").change(function () {
            if ($(this).is(':checked') && isAislePage()) {
                pushDataLayerProductCatalogFilterBy('top checkboxes', $(this).data('facet-name').toLowerCase().trim(), $(this).data('facet-value').toLowerCase().trim());
            }
        });

        $container.find(".choicesChips input[type=checkbox]").click(function () {
            lastSelectedFilterId = this.id;
            navigate($(this).data('custom'), $(this).attr('value'), false, false);
        });

        $container.find(".checkbox--standard input[type=checkbox]").change(function () {
            lastSelectedFilterId = this.id;
            navigate($(this).data('custom'), $(this).attr('value'), false, false);
        });

        $('.product-filter-container .select-dropdown li.select-dropdown__item').click(function () {
            lastSelectedFilterId = this.id;

            if (isAislePage()) {
                const selectedFiltersCategory = $(this).closest('.action__select-variant').find('.select-variant span').text().toLowerCase().trim();
                const selectedFiltersOption = $($(this).find('button span')[0]).text().toLowerCase().trim();

                pushDataLayerProductCatalogFilterBy('top dropdown list', selectedFiltersCategory, selectedFiltersOption);
            }

            // Determine facet position
            facetPosition = -1;
            valuePosition = -1;
            const $facetElement = $(this).closest('.select-dropdown');
            if ($facetElement.length) {
                facetPosition = $facetElement.index('.select-dropdown') + 1;
            }
            if ($(this).parent().length) {
                valuePosition = $(this).index() + 1;
            }

            navigate($(this).data('custom'), $(this).attr('value'), false, false);
        });

        $('.product-filter-container .select-dropdown li.select-dropdown__see-more').on('click keydown', function (e) {
            if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.keyCode === 13))) {
                $('.openFilter').click();
                let $filterDropDownValue = $(this).closest("div.action__select-variant").data("filter-name");
                let $sidePanelFilterToFocus = $('.products-filter--container').find('div[data-filter-name="' + $filterDropDownValue + '"]');
                $sidePanelFilterToFocus.find('.accordion--btn:not(.active--filter)').click();
                $sidePanelFilterToFocus.find('.js-show-more-filters').click();
                $('.product-filter--form-content .accordion').animate({scrollTop: $($sidePanelFilterToFocus).position().top - 70}, 'slow');
            }
        });

        // see more recipe
        $('.recipe-results .dropdown--list .select-dropdown li.select-dropdown__see-more').click(function (e) {
            if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.keyCode === 13))) {
                $('.openFilter').click();
                let $filterDropDownValue = $(this).closest("div.action__select-variant").data("filter-name");
                let $sidePanelFilterToFocus = $('.products-filter--container').find('div[data-filter-name="' + $filterDropDownValue + '"]');
                $sidePanelFilterToFocus.find('.accordion--btn:not(.active--filter)').click();
                $sidePanelFilterToFocus.find('.js-show-more-filters').click();
                $('.product-filter--form-content .accordion').animate({scrollTop: $($sidePanelFilterToFocus).position().top - 70}, 'slow');
            }
        });

        $('.recipe-results .dropdown--list .select-dropdown li.select-dropdown__item').click(function (e) {
            if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.keyCode === 13))) {
                lastSelectedFilterId = this.id;
                const selectedFiltersCategory = $(this).closest('.action__select-variant').find('.select-variant span').text().toLowerCase().trim();
                const selectedFiltersOption = $($(this).find('button span')[0]).text().toLowerCase().trim();
                pushDataLayerProductCatalogFilterBy('top dropdown list recipes', selectedFiltersCategory, selectedFiltersOption);

                navigate($(this).data('custom'), $(this).attr('value'), false, false);
            }
        });

        $container.find('a.removeAllFilters').on('click', function () {
            if (typeof freeTextSearch !== 'undefined') {
                let filter = freeTextSearch.split(':')[0];
                navigate(false, filter, true, false);
            } else {
                navigate(false, null, true, false);
            }
            // fix ga4 bug T4286-12840
            sessionStorage.setItem('isFromFilter', true);
        });
    }

    function bindShowHideMoreFilters($container) {
        if ($container === undefined) {
            $container = $(filtersContainersClass);
        }

        $container.on('click.filtersToggle', '.js-show-more-filters', function () {
            const $this = $(this);
            const loadCount = $this.attr('data-load-count') || 0;

            loadFilter(this.previousElementSibling, loadCount, loadFilterCallback);

            $this.siblings('.js-extra-filters').show();
            $('.extendAll').removeClass('extendAll');
        });
    }


    function loadFilterCallback(trigger, nextCount) {
        const $trigger = $(trigger);

        if (nextCount > 0) {
            $trigger.find('.js-show-more-label .js-next-count').text(nextCount);
            $trigger.attr('data-load-count', nextCount);
        } else {
            $trigger.removeClass('js-show-more-filters');
            $trigger.addClass('js-hide-all-filters');
            $trigger.children('.js-show-more-label').hide();
            $trigger.children('.js-hide-all-label').show();
            $trigger.attr('aria-expanded', 'true');
            $trigger.off('click.filtersToggle');
            $trigger.on('click.filtersToggle', hideAllFilters);
        }
    }

    function hideAllFilters() {
        const $this = $(this);
        $this.removeClass('js-hide-all-filters');
        $this.addClass('js-show-all-filters');
        $this.children('.js-hide-all-label').hide();
        $this.children('.js-show-all-label').show();
        $this.attr('aria-expanded', 'false');
        $this.off('click.filtersToggle');
        $this.on('click.filtersToggle', showAllFilters);
        $this.siblings('.js-extra-filters').slideUp('fast');
    }

    function showAllFilters() {
        const $this = $(this);
        $this.removeClass('js-show-all-filters');
        $this.addClass('js-hide-all-filters');
        $this.children('.js-show-all-label').hide();
        $this.children('.js-hide-all-label').show();
        $this.attr('aria-expanded', 'true');
        $this.off('click.filtersToggle');
        $this.on('click.filtersToggle', hideAllFilters);
        $this.siblings('.js-extra-filters').slideDown('fast');
    }

    function bindToggleFilter($container) {
        $container.on('click', '.accordion--btn', function () {
            $(this).toggleClass('active--filter');
        });
    }

    function bindCategoryExpand($filter) {
        $filter.find(".checkbox--standard.isMainCategory.hasChild").on('click', function () {
            if ($(this).hasClass('extendAll') && $filter.find('.js-filter-value').length == 0) {
                $(this).removeClass('extendAll');
                $filter.find('.js-show-more-filters').click();
            } else {
                toggleSubCategory($(this));
            }
        });
    }

    function preventWrappingMobile() {
        const flexItems = document.querySelectorAll('.dropdown--list > .mobile-only, .dropdown--list > .products-filter');
        if (flexItems.length) {
            let lastTop = flexItems[0].offsetTop;

            flexItems.forEach((item, index) => {
                if (item.offsetTop > lastTop) {
                    item.classList.add('wrapped');
                    lastTop = item.offsetTop;
                }
            });
        }
    }

    function toggleSubCategory($obj) {
        let category = $obj.find('span.filter-name').text().replace(/[^a-zA-Z]+/g, "");

        if ($obj.hasClass('closed')) {
            $obj.removeClass("closed");
            $('.' + category + '.isSubCategory').removeClass('collapsed');
        } else {
            $obj.addClass("closed");
            $obj.removeClass("minusDisplay");
            $('.' + category + '.isSubCategory').addClass('collapsed');
        }
    }

    //****************************************************************
    // Features
    //****************************************************************
    function loadFilter(filter, nbToLoad, callback) {
        let $filter = $(filter);
        let filterContainer = $filter.closest(filtersContainersClass);

        deactivateMobileFilters(filterContainer);

        let data = {
            filter: $filter.attr("data-load-more"),
            nbToLoad: nbToLoad,
            offset: $filter.children('.checkbox--standard').length,
            searchId: searchId
        };
        $.ajax({
            url: productSearchFilterUrl + fromEcomFlyerUniqueParam,
            type: 'POST',
            data: JSON.stringify(data),
            dataType: "html",
            header: {
                'Accept-Language': window['acceptLanguage']
            },
            contentType: 'application/json; charset=utf-8',
            success: function (responseData) {
                $filter.append(responseData);
                bindEventOnFilterClick($filter);
                bindEventOnProductToolsFilterClick($(productToolsFiltersContainerClass));
                bindShowHideMoreFilters($filter);
                bindToggleFilter($filter);
            },
            error: function (jqXHR, status, error) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    console.warn("Error when trying to load the filter selection fragment " + error);
                }
            },
            complete: function () {
                onExtraFiltersChange($filter, callback);
                bindCategoryExpand(($filter));
                activateMobileFilters(filterContainer);
            }
        });
    }

    function onExtraFiltersChange($filter, callback) {
        const $trigger = $filter.siblings('.js-show-more-filters:first');
        const displayedValuesCount = $filter.children('.js-filter-value').length;
        const totalValuesCount = $filter.attr('data-values-count');
        const remainingValuesCount = totalValuesCount - displayedValuesCount;

        if (callback !== undefined && callback instanceof Function) {
            const loadCount = $trigger.attr('data-load-count') || 0;
            const nextCount = Math.min(remainingValuesCount, loadCount);

            callback($trigger, nextCount);
        }
        if (remainingValuesCount <= 0) {
            deleteFilter($filter.attr("data-load-more"));
        }

        $(".checkbox--standard.isMainCategory.hasChild").each(function () {
            toggleSubCategory($(this));
        });
    }

    function deleteFilter(filterName) {
        let data = {
            filter: filterName,
            searchId: searchId
        };

        $.ajax({
            url: productSearchFilterUrl,
            type: 'DELETE',
            data: JSON.stringify(data),
            header: {
                'Accept-Language': window['acceptLanguage']
            },
            contentType: 'application/json; charset=utf-8',
            error: function (jqXHR, status, error) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    console.warn("Error when trying to clean filters from user's session " + error);
                }
            }
        })
    }

    function applyFiltersProductAjax(filtersUrl, isResetAllFilters, actionCause) {
        let $mobileFiltersContainer = $(filtersContainersClass);
        deactivateMobileFilters($mobileFiltersContainer);

        function focusOnLastSelectedCheckbox() {
            if (lastSelectedFilterId !== '') {
                // do not use $('#' + lastSelectedFilterId) since 'id' might contain characters breaking the js (ex: 'mob-100%petit')
                $('[id="' + lastSelectedFilterId + '"]').focus();
            }
        }

        // Remember already loaded extra filters in order to keep them after the section is refreshed
        const filterStats = [];
        if (!isResetAllFilters) {
            $mobileFiltersContainer.find('.js-extra-filters').each(function () {
                const $this = $(this);
                filterStats.push({
                    'filterName': $this.data('load-more'),
                    'extraFilterValuesCount': $this.find('.js-filter-value').length
                });
            });
        }

        $.ajax({
            type: 'POST',
            url: filtersUrl,
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify({
                'currentAisleId': currentAisleId,
                'filterStats': filterStats,
                'actionCause': actionCause
            }),
            success: function (data, textStatus, jqXHR) {
                replaceSearchProductFiltersContent(data, jqXHR);
                bindEventOnFilterClick($mobileFiltersContainer);
                bindEventOnProductToolsFilterClick($(productToolsFiltersContainerClass));
                focusOnLastSelectedCheckbox();
            },
            error: function (jqXHR, status, error) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    console.warn("Error to apply filters " + error);
                }
            },
            complete: function () {
                $mobileFiltersContainer.find('.js-extra-filters').each(function () {
                    const $extraFilters = $(this);
                    if ($extraFilters.find('.js-filter-value').length > 0) {
                        onExtraFiltersChange($extraFilters, loadFilterCallback);
                    }
                });
                bindCategoryExpand($(filtersContainersClass));
                activateMobileFilters($mobileFiltersContainer);
            }
        });
    }

    function navigate(isCustom, filterValue, isResetAllFilters, isAjax, actionCause, isSorting) {
        let searchUrl = (pageUrl.includes('recettes') || pageUrl.includes('recipes')) ? recipeSearchRefreshFiltersUrl : productSearchRefreshFiltersUrl;
        if (isResetAllFilters) {
            currentSortUrl = "?sortOrder=relevance";
            currentFilter = "";
            currentCustomQuery = "";
        }
        let url = isAjax ? searchUrl + appendUrl(currentSortUrl) : pageUrl + appendUrl(currentSortUrl);
        let sortOrder = typeof isSorting !== 'undefined';

        if (filterValue !== null) {
            lastFilterValue = pageUrl + appendUrl(currentSortUrl);

            let filter;
            if (isCustom) {
                filter = currentHybrisQuery + appendFilter('&customFilter=', filterValue);
            } else {
                filter = appendFilter('&filter=', filterValue) + currentCustomQuery;
            }
            filterToApply = filter;
            url += filter;
            lastFilterValue += filter;
        } else if (sortOrder) {
            currentSortUrl = SORT_ORDER_PARAM + isSorting;
            let redirectUrl;
            // update all facet values with correct sorting
            $('.products-filter--container')
                .find(".checkbox--standard input[type=checkbox]")
                .each(function () {
                    let currentValue = $(this).attr('value');
                    let newValue;
                    // regex to check if the filter value has only the sorting part (ex: %3Aprice-desc)
                    const regex = /^([^%]*%3A[^%]*)$/;
                    // if filter is not from Quick Shop, update it with the correct sorting
                    if (currentValue.indexOf(QUICK_SHOP_FILTER_ENCODED) === -1) {
                        if ($(this).attr('checked') === 'checked' && regex.test(currentValue)) {
                            newValue = `%3A${encodeURIComponent(isSorting)}`;
                        } else {
                            newValue = currentValue.replace(FILTER_ENCODED_REGEX, `%3A${encodeURIComponent(isSorting)}%3A`);
                        }
                        $(this).attr('value', newValue);
                    }

                });

            // if we are on a plp, and a filter is already applied, but no new filter is selected in the panel
            if (typeof currentFilter !== 'undefined' && currentFilter !== null && currentFilter.length > 0 && filterToApply == '') {
                let currentFilterIsQuickshop = currentFilter.indexOf(QUICK_SHOP_FILTER_ENCODED) !== -1;
                redirectUrl = pageUrl + appendUrl(SORT_ORDER_PARAM + isSorting) + (currentFilterIsQuickshop ? currentFilter : currentFilter.replace(FILTER_ENCODED_REGEX, `%3A${encodeURIComponent(isSorting)}%3A`));
            } else {
                // if a new filter has been selected in the panel
                // build redirection URL with current sorting selection and correct filters if necessary
                let filterToApplyIsQuickshop = filterToApply.indexOf(QUICK_SHOP_FILTER_ENCODED) !== -1;
                redirectUrl = pageUrl + appendUrl(SORT_ORDER_PARAM + isSorting) + (filterToApplyIsQuickshop ? filterToApply : filterToApply.replace(FILTER_ENCODED_REGEX, `%3A${encodeURIComponent(isSorting)}%3A`));
            }
            $filtersContainer.find('a.applyFilters').attr('href', redirectUrl);
        } else {
            if (isResetAllFilters) {
                lastFilterValue = pageUrl;
                url = isAjax ? searchUrl : pageUrl;
            } else {
                url += currentFilter;
                lastFilterValue = pageUrl + appendUrl(currentSortUrl) + currentFilter;
            }
        }

        if (!sortOrder) {
            if (typeof facetPosition === 'number' && typeof valuePosition === 'number' && facetPosition > 0 && valuePosition > 0) {
                const encodedFacetPos = encodeURIComponent(`${facetPosition}, ${valuePosition}`);
                url += appendUrl(`&facetPos=${encodedFacetPos}`);
            }
            if (isAjax) {
                applyFiltersProductAjax(url, isResetAllFilters, actionCause);
            } else {
                window.location = TINK.validateUrl(url);
            }
        }
    }



    // Fonction pour mettre � jour l'�tat des boutons
    function updateButtonsState() {
        const canScrollLeft = sideScrollContainer.classList.contains('can-scroll-left');
        const canScrollRight = sideScrollContainer.classList.contains('can-scroll-right');

        // Activer/d�sactiver le bouton pr�c�dent
        if (canScrollLeft) {
            $sideScrollBtnPrev.prop('disabled', false);
            $sideScrollBtnPrev.removeClass('disabled');
        } else {
            $sideScrollBtnPrev.prop('disabled', true);
            $sideScrollBtnPrev.addClass('disabled');
        }

        // Activer/d�sactiver le bouton suivant
        if (canScrollRight) {
            $sideScrollBtnNext.prop('disabled', false);
            $sideScrollBtnNext.removeClass('disabled');
        } else {
            $sideScrollBtnNext.prop('disabled', true);
            $sideScrollBtnNext.addClass('disabled');
        }
    }

    if (sideScrollContainer && sideScrollContainer instanceof Element) {
        // Observer les changements de classes avec MutationObserver
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    updateButtonsState();
                }
            });
        });

        observer.observe(sideScrollContainer, {
            attributes: true,
            attributeFilter: ['class']
        });

        updateButtonsState();

    }


    function scrollNavFilters() {
        const sideScrollDistance = 200;

        $sideScrollBtnNext.removeClass("disabled");
        $sideScrollBtnNext.children().removeClass("disabled");

        function sideScroll(element, direction, speed, distance, step) {
            scrollAmount = 0;
            var slideTimer = setInterval(function () {
                if (direction == 'left') {
                    element.scrollLeft -= step;
                } else {
                    element.scrollLeft += step;
                }
                scrollAmount += step;
                if (scrollAmount >= distance) {
                    window.clearInterval(slideTimer);
                }
            }, speed);
        }

        function clickArrowToScroll(btnArrow, actionToScroll) {

            btnArrow.on(actionToScroll, function () {

                if (btnArrow == $sideScrollBtnPrev) {
                    sideScroll(sideScrollContainer, 'left', 25, sideScrollDistance, 10);
                }

                if (btnArrow == $sideScrollBtnNext) {
                    sideScroll(sideScrollContainer, 'right', 25, sideScrollDistance, 10);
                }


            })
        }

        clickArrowToScroll($sideScrollBtnNext, 'click');
        clickArrowToScroll($sideScrollBtnPrev, 'click');
        clickArrowToScroll($sideScrollContainer, 'mousemove');

    }

    function scrollToSelectedCategory() {
        const selectedCategory = document.querySelector('.selected_category');
        let positionSelectedCategory = selectedCategory.offsetLeft;

        sideScrollContainer.scrollBy({
            left: positionSelectedCategory,
            behavior: 'smooth'
        });
    }

    if ($('.catalog-nav__sub-items').length) {
        let isDown = false;
        let startX;
        let scrollLeft;

        if (sliderScrollWidth > sliderWidth) {
            scrollNavFilters();

            sideScrollContainer.addEventListener('mousedown', (e) => {
                isDown = true;
                sideScrollContainer.classList.add('active');
                startX = e.pageX - sideScrollContainer.offsetLeft;
                scrollLeft = sideScrollContainer.scrollLeft;
            });
            sideScrollContainer.addEventListener('mouseleave', () => {
                isDown = false;
                sideScrollContainer.classList.remove('active');
            });
            sideScrollContainer.addEventListener('mouseup', () => {
                isDown = false;
                sideScrollContainer.classList.remove('active');
            });
            sideScrollContainer.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - sideScrollContainer.offsetLeft;
                const walk = (x - startX) * 2; //scroll-fast
                sideScrollContainer.scrollLeft = scrollLeft - walk;
            });
        }
    }

    //****************************************************************
    // Update dom
    //****************************************************************
    function replaceSearchProductFiltersContent(data, jqXHR) {
        data = data.trim();
        let $container = $filtersContainer.find('.product-filter--form-content');
        let $result = $($.parseHTML(data));
        let $newContent = $result.find('.product-filter--form-content');
        currentCustomQuery = $newContent.attr('data-current-custom-query');

        if (typeof currentCustomQuery == 'undefined') {
            currentCustomQuery = "";
        }
        $container.html($newContent);
        searchId = jqXHR.getResponseHeader("searchId");
    }

    //****************************************************************
    // Progress indicator
    //****************************************************************
    function deactivateMobileFilters($container) {
        if ($container === undefined) {
            $container = $(filtersContainersClass);
        }
        $container.find('button').attr('disabled', true);
        $container.find('input[type=checkbox]').attr('disabled', true);
        $container.find('.product-filter--progress-indicator').addClass('veil');
    }

    function activateMobileFilters($container) {
        if ($container === undefined) {
            $container = $(filtersContainersClass);
        }
        $container.find('button').removeAttr('disabled');
        $container.find('input[type=checkbox]').removeAttr('disabled');
        $container.find('.product-filter--progress-indicator').removeClass('veil');
    }

    //****************************************************************
    // Util
    //****************************************************************
    function appendFilter(name, value) {
        return value ? name + value : '';
    }

    function appendUrl(url) {
        return url ? url : '';
    }

    function isAislePage() {
        const currentURL = window.location.href;
        return currentURL.includes("/allees/") || currentURL.includes("/aisles/");
    }

    if (sliderScrollWidth > sliderWidth) {
        scrollToSelectedCategory();
    }

    const containerNav = document.querySelector('.navSideScroll');
    horizontalSwipeNav.arrowGestion(containerNav, false)

});
